import React, {useState, useEffect, Fragment} from 'react';
import { ListItem, ListItemText,Button, Box, Stack } from '@mui/material';
import  useACS from '../../hooks/useACS';
import FlatDevices from './FlatDevices';
import useLog from '../../hooks/useLog';

const Flat = ({ flat, selectedFlatId, handleFlatSelected }) => {

  const [showDevices, setShowDevices] = useState(false);
  const {LogInfo} = useLog();
  const {startCall} = useACS();


useEffect(() => {
  if(selectedFlatId !== flat.flatid){
    setShowDevices(false);
    return;
  }
  
  if (flat.devices.length===1){
    LogInfo("flat has only one device, calling device: " + devicePixelRatio.displayName);
    startCall(flat.devices[0]);
    return;
  }
  else{
    LogInfo("showing flat devices");
    setShowDevices(true)
    return;
  }
},[selectedFlatId]);

const flatSelected = () => {
 handleFlatSelected(flat.flatid);
};
  return (
    <Fragment>
    <ListItem className="list-item-action" onClick={flatSelected}>
        <Button edge="start" aria-label="call"
                sx={{
                    color: 'white', // White text
                    borderColor: 'white', // White border
                    borderRadius: '8px', // Rounded border
                    fontSize: '16px', // Larger font size
                    border: '1px solid', // Border style
                    padding: '8px 16px', // Padding for better appearance
                    width: '120px', // Button width
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 0.1)', // Background color on hover
                    },
                  }}
        >
          {flat.flatname}
        </Button>
        <Box sx={{ mx: 2, flexGrow: 1, textAlign: 'start', direction: 'inherit' }}>
          <ListItemText sx={{color:'white'}} 
            primaryTypographyProps={{
                sx: {
                color: 'white',
                fontWeight: 'light', // Bold font weight
                fontSize: '30px', // Larger font size
                },
            }}>{flat.familyName}
          </ListItemText>
        </Box>
    </ListItem>
    {showDevices &&
      <FlatDevices devices={flat.devices} />
    }  
    </Fragment>
  );
};

export default Flat;